<template>
    <div>
        <router-view name="brandModal"></router-view>
        <v-card flat class="ma-5">
            <v-card-title>
                <v-row>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="primary"
                        class="mb-2"
                        :to="{ name: $route.meta.addRoute, params: { requesterType: $route.meta.requesterType, requesterId: this.id } }"
                    >
                        <v-icon>add</v-icon> Cadastrar Marca
                    </v-btn>

                    <v-btn
                        :loading="loading"
                        :disabled="loading"
                        class="ml-1"
                        color="purple"
                        :dark="!loading"
                        @click.prevent="loadData()"
                    >
                        Atualizar
                    </v-btn>
                </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <data-table :setup.sync="dataTable" @delete-item="deleteItem"></data-table>
        </v-card>
    </div>
</template>

<script>
import API from '@/api'
import DataTable from '@/components/DataTable'

export default {
    name: 'detail-tab-workedhour',
    props: ['id'],
    components: {
        DataTable
    },
    vm: this,
    data: function (vm) {
        return {
            loading: true,
            dataTable: {
                loading: true,
                itemName: 'marca',
                headers: [
                    {
                        text: 'Processo',
                        value: 'processNumber',
                        width: '15%',
                        align: 'center'
                    },
                    { text: 'Marca', value: 'brand', width: '45%' },
                    {
                        text: 'Apresentação',
                        value: 'presentation',
                        width: '15%',
                        align: 'center'
                    },
                    {
                        text: 'Natureza',
                        value: 'nature',
                        width: '15%',
                        align: 'center'
                    },
                    {
                        text: 'Ações',
                        value: 'actions',
                        align: 'center',
                        sortable: false,
                        edit: false,
                        delete: true,
                        width: '10%'
                    }
                ],
                items: [],
                totalItems: 0,
                requesterType: vm.$route.meta.requesterType,
                requesterId: undefined,
                requesterItemId: 'objectId',
                detailTo: vm.$route.meta.detailTo,
                editTo: 'EditarMarca',
                pagination: {
                    multiSort: true,
                    mustSort: false,
                    page: 1,
                    itemsPerPage: 500,
                    groupBy: [],
                    groupDesc: [],
                    sortBy: ['createdAt'],
                    sortDesc: [true],
                    sortFormated: [{ value: 'createdAt', descending: true }]
                },
                sortingTimeout: undefined,
                footerProps: {
                    itemsPerPageOptions: [500, 250, 100, 50, 25, 10]
                }
            }
        }
    },
    watch: {
        'dataTable.pagination.sortBy': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (this.dataTable.sortingTimeout !== undefined) clearTimeout(this.dataTable.sortingTimeout)
                    this.dataTable.sortingTimeout = setTimeout(() => {
                        this.loadData()
                    }, 1000)
                }
            },
            deep: true
        },
        'dataTable.pagination.page': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        'dataTable.pagination.itemsPerPage': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        '$route': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.loadData()
    },
    methods: {
        getSortFormated (sortArray) {
            const sortFormated = sortArray.map((sortObj) => {
                return `${(sortObj.descending) ? '-' : ''}${sortObj.value}`
            })
            return sortFormated.join()
        },
        async loadData () {
            await this.$helpers.sleep(0)
            window.getApp.refreshBrands = false
            this.loading = true
            this.dataTable.loading = true
            this.dataTable.items = []
            this.dataTable.requesterId = this.$route.params.id
            const endpoint = API.EndPoints.getCorporateBrands
            const where = {
                client: {
                    __type: 'Pointer',
                    className: 'Client',
                    objectId: this.$route.params.id
                }
            }

            const params = {
                limit: this.dataTable.pagination.itemsPerPage,
                skip: (this.dataTable.pagination.page - 1) * this.dataTable.pagination.itemsPerPage,
                count: true,
                order: this.getSortFormated(this.dataTable.pagination.sortFormated),
                where: JSON.stringify(where),
                include: [],
                excludeKeys: 'ACL,image,body,client'
            }

            new API(endpoint, params).request().then(response => {
                this.dataTable.items = response.body.results
                this.dataTable.totalItems = response.body.count
                this.loading = false
                this.dataTable.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        async deleteItem (item) {
            let endpoint = API.EndPoints.deleteCorporateBrand
            endpoint.id = item.objectId
            let msg = ''
            await new API(endpoint).request()
                .then(
                    () => { msg = 'Marca removida com sucesso!' },
                    (error) => { msg = (error.status !== 0) ? error.data.error : '' }
                )
            if (msg !== '') alert(msg)
            this.loadData()
        }
    }
}
</script>
